module.exports = {"fr-FR":{"errors":{"invalid":"n'est pas valable","missing":"ne peut pas rester en blanc","taken":"est déjà utilisé"}}}